import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { environment } from '../../../../environments/environment'
import { ResourceSlug } from '../../../shared/enums/wordpress/wp-resource-slug.enum'

type ChangeRequestDto = {
  description: string
  email: string
  affiliation: string
  linkToResource: string
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(private http: HttpClient) {}

  askForChange(
    resourceType: ResourceSlug,
    body: ChangeRequestDto
  ): Promise<any> {
    return this.http
      .post(`${environment.apiCatalogBaseUrl}report/${resourceType}`, body)
      .toPromise()
  }

  askForEditAccess(resourceType: ResourceSlug, id: number): Promise<any> {
    return this.http
      .post(
        `${environment.apiCatalogBaseUrl}report/edit/${resourceType}/${id}`,
        {}
      )
      .toPromise()
  }
}
